import {useBillV2} from '@resurs-internal/rb-app-api';
import {createFileRoute, useNavigate} from '@tanstack/react-router';
import {PaymentCallbackUnknownPage} from 'features/shared/payment/pages/PaymentCallbackUnknownPage';
import {useFeatureFlags} from 'hooks';
import {useEffect} from 'react';
import {useQueryClient} from '@tanstack/react-query';

export const Route = createFileRoute(
  '/_protected/bill-payment/$billId/callback/_statuses/unknown',
)({
  component: RouteComponent,
});

function RouteComponent() {
  const flags = useFeatureFlags();
  const navigate = useNavigate();
  const queryClient = useQueryClient();

  useEffect(() => {
    if (flags.statementSessionPayments || flags.billSessionPayments) {
      queryClient.invalidateQueries({queryKey: ['accounts', 'saved']});
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const {billId} = Route.useParams();
  const search = Route.useSearch();
  const {bill} = useBillV2(billId);
  const payment = bill?.payments.find((p) => p.id === search.paymentId);

  return (
    <PaymentCallbackUnknownPage
      pageId="bill_payment_unknown"
      onClose={() =>
        navigate({to: '/home/statements/$id', params: {id: billId}})
      }
      payment={payment}
      bill={bill}
    />
  );
}
